import axios from "@/plugins/axios";

const getAll = (params) => {
  return axios.get('/notification', { params })
}

const getOne = (id) => {
  return axios.get(`/notification/${id}`)
}

const markAsRead = (id) => {
  return axios.put(`/notification/${id}/read`)
}

const markAllAsRead = () => {
  return axios.put(`/notification/read-all`)
}

const erase = (id) => {
  return axios.delete(`/notification/${id}`)
}

export default {
  getAll,
  getOne,
  markAsRead,
  erase,
  markAllAsRead
}
